<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="5" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				单笔结算单列表
			</el-col>
			<!-- <el-col :xs="24" :md="3" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<el-select style="width: 95%;" v-model="jiesuanvalue" placeholder="结算列表" @change="getvalue" clearable>
					<el-option v-for="item in jiesuan" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
				</el-select>
			</el-col> -->
			<el-col :xs="24" :md="19">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platdealapproval:pay')" type="primary" @click="openBatchPayDia">批量支付</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platdealapproval:audit')" type="info" @click="openBatchAuditDia">批量审核</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platdealapproval:export')" type="info" @click="exportHandle()">导出</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="info" @click="getDataList()">刷新</el-button>
					</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platdealapproval:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div class="mod-plat__platdealapproval}">
			<el-form label-width="110px" style="padding:10px 5px 0px;" ref="loginFormRef" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-row>
					<el-col :md="12" :lg="6">
						<el-form-item label="结算申请编号:" prop="dealCode"><el-input style="width: 100%;" v-model="dataForm.dealCode" placeholder="结算申请编号" clearable></el-input></el-form-item>
					</el-col>

					<el-col :md="12" :lg="12">
						<el-form-item label="结算金额:">
							<el-input v-model="dataForm.money1" placeholder="结算金额" style="width: 48%"></el-input>
							<span style="width:4%;text-align: center;display: inline-block;">~</span>
							<el-input v-model="dataForm.money2" placeholder="结算金额" style="width: 48%"></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="6">
						<el-form-item label="发布方:" prop="dealBody"><el-input style="width: 100%;" v-model="dataForm.dealBody" placeholder="请输入发布方名称" clearable></el-input></el-form-item>
					</el-col>
					<el-col :md="12" :lg="6">
						<el-form-item label="结算状态:" prop="status">
							<el-select style="width: 100%;" v-model="dataForm.status" placeholder="结算状态" clearable>
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="12">
						<el-form-item label="执行时间:">
							<el-date-picker
							 style="width: 48%"
							 	:picker-options='pickerStartOptions(dataForm.endDate)'
								v-model="dataForm.startDate"
								placeholder="开始时间"
								type="date"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
							></el-date-picker>
							<span style="width:4%;text-align: center;display: inline-block;">~</span>
							<el-date-picker
							 style="width: 48%"
								v-model="dataForm.endDate"
								:picker-options='pickerEndOptions(dataForm.startDate)'
								placeholder="结束时间"
								type="date"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
							></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="6">
						<el-form-item label-width="0px">
							<div style="text-align: right;">
								<el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
								<el-button type="info" @click="resetLoginForm">重置</el-button>
							</div>
						</el-form-item>

					</el-col>
				</el-row>
			</el-form>
			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;border-top:3px solid #F3F4F4;">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<!--  <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>-->
				<el-table-column label-class-name="column" label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column label-class-name="column" prop="dealCode" label="结算申请编号" header-align="center" align="center"></el-table-column>
				<el-table-column label-class-name="column" prop="taskCode" label="任务发布编号" header-align="center" align="center">
					 <template slot-scope="scope">
						<el-button type="text" size="small" @click="goTaskInfo(scope.row.taskId)">{{scope.row.taskCode}}</el-button>
					</template>
				</el-table-column>
				<el-table-column label-class-name="column" prop="acceptTaskCode" label="任务接受编号" header-align="center" align="center">
					 <template slot-scope="scope">
						<el-button type="text" size="small" @click="goTaskInfo(scope.row.taskId)">{{scope.row.acceptTaskCode}}</el-button>
					</template>
				</el-table-column>
				<el-table-column label-class-name="column" prop="contractCode" label="合同编号" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="infoHandle(scope.row.contractId)">{{scope.row.contractCode}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="taskType" label="任务大类" header-align="center" align="center" width="120">
                    <template slot-scope="scope">
                        {{ $getDictLabel("taskType", scope.row.taskType) }}
                    </template>
                </el-table-column>
				<el-table-column prop="publishName" label="发布方" header-align="center" align="center"></el-table-column>
				<el-table-column prop="realName" label="接收方" header-align="center" align="center"></el-table-column>
				<el-table-column prop="phone" label="手机号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="idCard" label="证件号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="bankNo" label="收款账号" header-align="center" align="center"></el-table-column>
				<el-table-column prop="bankName" label="开户行" header-align="center" align="center"></el-table-column>
				<el-table-column prop="unitPrice" label="单价" header-align="center" align="center"></el-table-column>
				<el-table-column prop="quantity" label="数量" header-align="center" align="center"></el-table-column>
				<el-table-column prop="dealMoney" label="金额" header-align="center" align="center"></el-table-column>
				<el-table-column label-class-name="column" width="100" prop="status" label="结算单状态" header-align="center" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status == 0" size="small" type="danger">草稿</el-tag>
						<el-tag v-if="scope.row.status == 1" size="small" type="warning">待审核</el-tag>
						<el-tag v-if="scope.row.status == 2" size="small">待支付</el-tag>
						<el-tag v-if="scope.row.status == 3" size="small" type="success">已支付</el-tag>
						<el-tag v-if="scope.row.status == 4" size="small" type="success">已到账</el-tag>
						<el-tag v-if="scope.row.status == 5" size="small" type="warning">支付失败</el-tag>
						<el-tag v-if="scope.row.status == 6" size="small" type="warning">重发中</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="reviewer" label="审核人" header-align="center" align="center"></el-table-column>
				<el-table-column prop="updateDate" label="操作日期" header-align="center" align="center" type="datetime"  format="yyyy-MM-dd"></el-table-column>
				<el-table-column label-class-name="column" :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
				    <template slot-scope="scope">
						<el-button v-if="scope.row.status == 1 && $hasPermission('plat:platapplyapproval:checked')" style="word-break: break-all;white-space: wrap;" type="text" size="small"  class="el-button--primary" @click="openAuditDia(scope.row)">审核</el-button>
						<el-button v-if="scope.row.status == 2 && $hasPermission('plat:platapplyapproval:pay')" style="word-break: break-all;white-space: wrap;" type="text"  class="el-button--primary" size="small" @click="openPayDia(scope.row,1)">支付</el-button>
						<el-button v-if="scope.row.status == 5 && $hasPermission('plat:platapplyapproval:pay')" style="word-break: break-all;white-space: wrap;" type="text"  class="el-button--primary" size="small" @click="openPayDia(scope.row,2)">重发</el-button>
				    </template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="limit"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
				@size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle"
			></el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
		<el-dialog title="审核" :visible.sync="auditDia" width="527px" @close="auditDiaCancel">
			<el-form  label-width="40px">
				<el-row type="flex" justify="space-between" v-for="item in auditDiaItemList" :key="item.realName">
					<el-col :span="10">
					<el-form-item  label="姓名"><el-input style="width: 100%;" disabled v-model="item.realName"></el-input></el-form-item>
					</el-col>
					<el-col :span="10">
					<el-form-item  label="金额"><el-input style="width: 100%;" disabled v-model="item.money"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="备注">
					<el-input type="textarea" :autosize="{ minRows: 2}" placeholder="请输入备注" v-model="auditFormData.reason"></el-input>
				</el-form-item>
				<div style="textAlign:right;">合计结算金额：{{allAduitMoney}}</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="batchAuditTask('pass')">确 定</el-button>
			<el-button @click="batchAuditTask('')">不通过</el-button>
			</span>
		</el-dialog>
		<set-pay  ref="SetPay" @refreshDataList="getDataList"></set-pay>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module';
import AddOrUpdate from './platdealapproval-add-or-update';
import { addDynamicRoute } from '@/router';
import setPay from "./set-pay.vue";
export default {
	mixins: [mixinViewModule],
	data() {
		return {
			pickerStartOptions(endTime){
                return {
                    disabledDate(time){
                        if(endTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() > new Date(endTime +' 00:00:00').getTime();
                        }
                    }
                } 
            },
            pickerEndOptions(startTime){
                return {
                    disabledDate(time){
                        if(startTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() < new Date(startTime +' 00:00:00').getTime();
                        }
                    }
                }
            },
			options: [
				{
					value: '1',
					label: '待审核'
				},
				{
					value: '2',
					label: '待支付'
				},
				{
					value: '3',
					label: '已支付'
				},
				{
					value: '4',
					label: '已到账'
				},
				{
					value: '5',
					label: '支付失败'
				},
				{
					value: '6',
					label: '重发中'
				}
			],
			jiesuan: [
				{
					value: '0',
					label: '企业结算列表'
				},
				{
					value: '1',
					label: '个人结算列表'
				}
			],
			value: '',
			jiesuanvalue:"企业结算列表",
			mixinViewModuleOptions: {
				getDataListURL: '/sys/plat/deal/approval/page',
				getDataListIsPage: true,
				deleteURL: '/sys/plat/deal/approval',
				deleteIsBatch: true,
				exportURL: '/sys/plat/deal/approval/export'
			},
			dataForm: {
				money1: '',
				money2: '',
				dealCode: '',
				dealBody: '',
				status: '',
				startDate: '',
				endDate: ''
			},
			auditFormData:{
				reason:'',
			},
			auditDiaItemList:[],
			payDia:false,
			auditDia:false
		};
	},
	components: {
		AddOrUpdate,
		setPay
	},
	computed:{
		allAduitMoney:function(){
			if(this.auditDiaItemList.length){
				var num = 0;
				this.auditDiaItemList.forEach(item=>{
					num+=Number(item.money)
				})
				return num.toFixed(2);
			}else{
				return 0
			}
		}
	},
	activated(){
	    this.dataForm = this.$store.state.listForm ? this.$store.state.listForm : this.dataForm
		this.$nextTick(() => {
			this.query();
		})
		return false;
	},
	methods:{
		//打开审核弹窗
		openBatchAuditDia(){
			if(!this.dataListSelections.length){
				this.$message({
					message: '请选择批量审核的信息！',
					type: 'error',
					duration: 500,
				})
				return
			}
			this.auditDiaItemList = this.dataListSelections.map(item=>{
				return {
					id:item.id,
					name:item.userName,
					realName:item.realName,
					money:item.dealMoney
				}
			})
			this.auditDia = true;
		},
		//单个审核
		openAuditDia(item){
			this.auditDiaItemList = [{
				id:item.id,
				name:item.userName,
				realName:item.realName,
				money:item.dealMoney
			}];
			this.auditDia = true;
		},
		//批量审核接口
		batchAuditTask(result){
			this.$confirm(this.$t('prompt.info', { 'handle': '审核任务'}), this.$t('prompt.title'), {
				confirmButtonText: this.$t('confirm'),
				cancelButtonText: this.$t('cancel'),
				type: 'warning'
			}).then(()=>{
				this.$http.post('/sys/plat/deal/approval/audit',this.auditDiaItemList.map((item)=>{return {id:item.id,result:result,reason:this.auditFormData.reason}})).then(({ data: res })=>{
				if (res.code !== 0) {
					return this.$message.error(res.msg)
				}
				this.auditDiaCancel();
				this.$message({
					message: this.$t('prompt.success'),
					type: 'success',
					duration: 500,
					onClose: () => {
						this.query()
					}
				})
				}).catch(()=>{})
			}).catch(()=>{})
		},
		auditDiaCancel(){
			this.auditDia = false;
			this.auditDiaItemList = [];
			this.auditFormData = {
				reason:''
			}
		},
		openPayDia(row,num){

			this.$refs.SetPay.init();
			this.$refs.SetPay.ids = [row.id];
            this.$refs.SetPay.getPayDetails();
			if(num == 2){
            	this.$refs.SetPay.parentIsErr = true;
			}else{
            	this.$refs.SetPay.parentIsErr = false;
			}
		},
		openBatchPayDia(){
			if(!this.dataListSelections.length){
				this.$message({
					message: '请选择批量支付的信息！',
					type: 'error',
					duration: 500,
				})
				return
			}
			let data = this.dataListSelections.map(item=>{
				return {
					name:item.userName,
					realName:item.realName,
					money:parseFloat(item.dealMoney)*(1-(parseFloat(item.payFee)/100))
				}
			})
			this.$refs.SetPay.init();
			this.$refs.SetPay.ids = this.dataListSelections.map(item=>{
				return item.id
			});
            this.$refs.SetPay.getPayDetails();
			
		},
		resetLoginForm(){
			this.$refs.loginFormRef.resetFields();
			this.dataForm.money1 = "";
			this.dataForm.money2 = "";
			this.dataForm.startDate = "";
			this.dataForm.endDate = "";
			this.getDataList();
		},
		childHandle (id) {
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
		  // 路由参数
		  const routeParams = {
        routeName: `${this.$route.name}__结算申请`,
        title: `结算申请`,
        path: 'plat/platapply-approval',
        params: {
          id: id,
          typedata: 2
        }
		  }
		  // 动态路由
		  addDynamicRoute(routeParams, this.$router)
		},
		getvalue(e){
			if(e == 1){
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
				const routeParams = {
							routeName: `${this.$route.name}__个人结算申请单`,
							title: `个人结算申请单`,
							path: 'plat/platapply-approval-gr'
				}
				// 动态路由
				addDynamicRoute(routeParams, this.$router)
			}
		},
		// 查看
		infoHandle(id) {
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
			// 路由参数
			const routeParams = {
						routeName: `${this.$route.name}__合同详情`,
						title: `合同详情`,
						path: 'plat/platcontract-info',
						params: {
						  id:id
						}
			}
			// 动态路由
			addDynamicRoute(routeParams, this.$router)
		},
		goTaskInfo(id){
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
			// 路由参数
			const routeParams = {
				routeName: `${this.$route.name}__任务详情`,
				title: `任务详情`,
				path: 'plat/platttask-info',
				params: {
					id:id
				}
			}
			// 动态路由
			addDynamicRoute(routeParams, this.$router)
		},
		taskinfoHandle(id) {
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
			const routeParams = {
				routeName: `${this.$route.name}__任务详情`,
				title: `任务详情`,
				path: 'plat/platttask-info',
				params: {
					id:id
				}
			}
			// 动态路由
			addDynamicRoute(routeParams, this.$router)
		}
	}
};
</script>
<style>
	.el-button{
		white-space:normal;
	}
</style>
